import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  overwriteExistingPackages: {
    defaultMessage: 'Overwrite existing values for all fields included in the CSV',
    id: '6gjEHS',
    description: 'Option to update existing custom packages',
  },
  helpContentText: {
    defaultMessage:
      'Upload a CSV file to create or update custom packages. Need help formatting? <file>Download our sample CSV file</file> or <helpLink>learn more about importing a CSV.</helpLink>',
    id: 'axxkVH',
    description: 'Custom Package Import help content text',
  },
  uploadFile: {
    defaultMessage: 'Upload File',
    id: '8cjYM6',
    description: 'Title for the first step of the import process',
  },
});
